import script from "./Testimonials.vue?vue&type=script&setup=true&lang=js"
export * from "./Testimonials.vue?vue&type=script&setup=true&lang=js"

import "./Testimonials.vue?vue&type=style&index=0&id=4edb298d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4edb298d"]])

export default __exports__